import { supabase } from './supabaseClient';
//git bump
export interface ActivityLogCreateInput {
  facilityId: string;
  residentId: string;
  activityText: string;
  dimensionIds: string[]; // wellness_dimensions.id UUIDs as strings
  loggedAt?: Date;
}

export interface ActivityLogRecord {
  id: string;
  facilityId: string;
  residentId: string;
  activityText: string;
  dimensionIds: string[];
  loggedAt: string;
  createdAt: string;
}

/**
 * Local (Supabase) persistence for ActivityLogger submissions.
 *
 * This is intended as a "safety mechanism" so user-entered activity is retained
 * even if upstream CareDaily logging is temporarily unavailable.
 */
export class ActivityLogStorageService {
  static async createActivityLog(input: ActivityLogCreateInput): Promise<ActivityLogRecord> {
    const facilityId = (input.facilityId || '').trim();
    const residentId = (input.residentId || '').trim();
    const activityText = (input.activityText || '').trim();
    const dimensionIds = input.dimensionIds || [];

    if (!facilityId) throw new Error('facilityId is required to store activity log');
    if (!residentId) throw new Error('residentId is required to store activity log');
    if (!activityText) throw new Error('activityText is required to store activity log');
    if (dimensionIds.length === 0) throw new Error('dimensionIds is required to store activity log');

    const loggedAt = (input.loggedAt || new Date()).toISOString();

    const { data, error } = await supabase
      .from('activity_logs')
      .insert({
        facility_id: facilityId,
        resident_id: residentId,
        activity_text: activityText,
        dimension_ids: dimensionIds,
        logged_at: loggedAt,
      })
      .select('*')
      .single();

    if (error) {
      console.error('❌ Failed to store activity log in Supabase:', error);
      throw error;
    }

    return {
      id: data.id,
      facilityId: data.facility_id,
      residentId: data.resident_id,
      activityText: data.activity_text,
      dimensionIds: data.dimension_ids,
      loggedAt: data.logged_at,
      createdAt: data.created_at,
    };
  }
}

